<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>

                <v-layout v-if="merchantUuid && merchant.length > 1" wrap align-center>
                    <v-flex xs4 sm4 d-flex>
                        <v-select v-model="merchantUuid" @change="getDashboardWeeklyStats();
                                                                  getDashboardPaymentStats();
                                                                  getDashboardScheduleStats();
                                                                  getAgentStats();
                                                                  getAuthLevels();"
                                                                  :items="merchant"
                                                                  item-text="name"
                                                                  item-value="uuid"
                                                                  label="Companies"></v-select>
                    </v-flex>
                </v-layout>

                <v-layout v-if="scheduleStats && paymentStats" row wrap mb-1>
                    <v-flex xs12 md6 xl6>
                        <v-card>
                            <v-card-title class="primary white--text" dense>
                                <v-list-tile-title class="subheading font-weight-regular">Schedules Forecast</v-list-tile-title>
                            </v-card-title>
                            <v-layout row wrap pa-3>
                                <v-flex v-for="(row, i) in scheduleStats" :key="row.n" xs2>
                                    <v-card color="blue lighten-2" dark raised class="pa-3 elevation-3">
                                        <v-list-tile-content class="mb-2">
                                            <v-list-tile-title v-if="i == 0" class="title">Today</v-list-tile-title>
                                            <v-list-tile-title v-else class="title">{{ row.suffix }}</v-list-tile-title>
                                        </v-list-tile-content>
                                        <span v-if="row.amount" class="body-1">£{{ row.amount }}</span>
                                        <span v-else class="body-1">£0.00</span>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 md6 xl6>
                        <v-card>
                            <v-card-title class="primary white--text" dense>
                                <v-list-tile-title class="subheading font-weight-regular">Today's Payments</v-list-tile-title>
                            </v-card-title>
                            <v-layout row wrap pa-3>
                                <v-flex v-for="(row, i) in paymentStats[0]" :key="i" xs3>
                                    <v-card color="blue lighten-2" dark raised class="pa-3 elevation-3">
                                        <v-list-tile-content class="mb-2">
                                            <v-list-tile-title v-if="i == 'total'" class="title">Total</v-list-tile-title>
                                            <v-list-tile-title v-if="i == 'moto'" class="title">Moto</v-list-tile-title>
                                            <v-list-tile-title v-if="i == 'scheduler'" class="title">Scheduler</v-list-tile-title>
                                            <v-list-tile-title v-if="i == 'payByLink'" class="title">Pay By Link</v-list-tile-title>
                                        </v-list-tile-content>
                                        <span v-if="row" class="body-1">£{{ row }}</span>
                                        <span v-else-if="!row" class="body-1">£0.00</span>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12 md6 xl6>
                        <v-card>
                            <v-card-title class="primary white--text" dense>
                                <v-list-tile-title class="subheading font-weight-regular">Weekly Transactions Value Comparison</v-list-tile-title>
                            </v-card-title>
                            <div class="pa-2" height="400">
                                <canvas ref="transactions-value-weekly-comparison" id="transactions-value-weekly-comparison" width="400" height="400"></canvas>
                            </div>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md6 xl6>
                        <v-card>
                            <v-card-title class="primary white--text" dense>
                                <v-list-tile-title class="subheading font-weight-regular">Weekly Transactions Volume Comparison</v-list-tile-title>
                            </v-card-title>
                            <div class="pa-2" height="400">
                                <canvas ref="transactions-volume-weekly-comparison" id="transactions-volume-weekly-comparison" width="400" height="400"></canvas>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card>
                            <v-card-title class="primary white--text" dense>
                                <v-list-tile-title class="subheading font-weight-regular">Weekly Transactions Value & Volume Comparison</v-list-tile-title>
                            </v-card-title>

                            <v-data-table id="comparison-table" :headers="headers" :items="data" :loading="loading" hide-actions>
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                <template v-slot:items="props">
                                    <td class="text-xs-left font-weight-bold" :style="{color:'rgba(0,0,0,.54)'}">{{ props.item.day }}</td>
                                    
                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.dbValChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbVal) }}<br>
                                                {{ props.item.dbValChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else-if="Math.sign(props.item.dbValChange) == 0" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#1867c0">mdi-arrow-right-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbVal) }}<br>
                                                {{ props.item.dbValChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbVal) }}<br>
                                                {{ props.item.dbValChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.dbVolChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.dbVol) }}<br>
                                                {{ props.item.dbVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else-if="Math.sign(props.item.dbVolChange) == 0" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#1867c0">mdi-arrow-right-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbVol) }}<br>
                                                {{ props.item.dbVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.dbVol) }}<br>
                                                {{ props.item.dbVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.crValChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.crVal) }}<br>
                                                {{ props.item.crValChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else-if="Math.sign(props.item.crValChange) == 0" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#1867c0">mdi-arrow-right-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.crVal) }}<br>
                                                {{ props.item.crValChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.crVal) }}<br>
                                                {{ props.item.crValChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.crVolChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.crVol) }}<br>
                                                {{ props.item.crVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else-if="Math.sign(props.item.crVolChange) == 0" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#1867c0">mdi-arrow-right-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.crVol) }}<br>
                                                {{ props.item.crVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.crVol) }}<br>
                                                {{ props.item.crVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.dbFailValChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbFailVal) }}<br>
                                                {{ props.item.dbFailValChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else-if="Math.sign(props.item.dbFailValChange) == 0" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#1867c0">mdi-arrow-right-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbFailVal) }}<br>
                                                {{ props.item.dbFailValChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbFailVal) }}<br>
                                                {{ props.item.dbFailValChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.dbFailVolChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.dbFailVol) }}<br>
                                                {{ props.item.dbFailVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else-if="Math.sign(props.item.dbFailVolChange) == 0" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#1867c0">mdi-arrow-right-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.dbFailVol) }}<br>
                                                {{ props.item.dbFailVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.dbFailVol) }}<br>
                                                {{ props.item.dbFailVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>
                                    
                                    <td class="text-xs-left">
                                        <v-layout row wrap align-center>
                                            <v-flex xs2>
                                                <v-icon v-if="props.item.failureRateVal > props.item.lastFailureRateVal" class="mr-1" size="16" color="#e53935">mdi-arrow-up-bold</v-icon>
                                                <v-icon v-else class="mr-1" size="16" color="#66bb6a">mdi-arrow-down-bold</v-icon>
                                            </v-flex>
                                            <v-flex>
                                                {{ props.item.failureRateVal }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout row wrap align-center>
                                            <v-flex xs2>
                                                <v-icon v-if="props.item.failureRateVol > props.item.lastFailureRateVol" class="mr-1" size="16" color="#e53935">mdi-arrow-up-bold</v-icon>
                                                <v-icon v-else class="mr-1" size="16" color="#66bb6a">mdi-arrow-down-bold</v-icon>
                                            </v-flex>
                                            <v-flex>
                                                {{ props.item.failureRateVol }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>
                                    
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout v-if="authLevels && agentStats" row wrap>
                    <v-flex xs12 md6>
                        <v-card>
                            <v-card-title class="primary white--text dense" dense>
                                <v-list-tile-title class="subheading font-weight-regular">Authorisation Statistics For {{ authLevels[0].monthName }}</v-list-tile-title>
                            </v-card-title>

                            <v-layout row wrap pa-3>
                                <v-flex xs4>
                                    <v-card color="blue lighten-2" dark raised class="pa-3 elevation-3">
                                        <v-list-tile-content class="mb-2">
                                            <v-list-tile-title class="title">Summary</v-list-tile-title>
                                        </v-list-tile-content>
                                        <span class="body-1"><b>Total:</b> {{ authLevels[0].totalTransactions }} / 20,000</span><br>
                                        <span class="body-1"><b>Visa:</b> {{ authLevels[0].visaTotal }}</span><br>
                                        <span class="body-1"><b>Mastercard:</b> {{ authLevels[0].masterTotal }}</span>
                                    </v-card>
                                </v-flex>
                                <v-flex xs4>
                                    <v-card :class="breach" light raised class="pa-3 elevation-3">
                                        <v-list-tile-content class="mb-2">
                                            <v-list-tile-title class="title">Visa</v-list-tile-title>
                                        </v-list-tile-content>
                                        <span class="body-1"><b>Successful:</b> {{ authLevels[0].visaSuccess }} / {{ authLevels[0].visaSuccessRatio }}%</span><br>
                                        <span class="body-1"><b>Failure:</b> {{ authLevels[0].visaFail }} / {{ authLevels[0].visaFailureRatio }}%</span><br>
                                        <span class="body-1"><b>Breach Threshold:</b> {{ authLevels[0].visaBreach }}%</span>
                                    </v-card>
                                </v-flex>
                                <v-flex xs4>
                                    <v-card :class="breach" light raised class="pa-3 elevation-3">
                                        <v-list-tile-content class="mb-2">
                                            <v-list-tile-title class="title">Mastercard</v-list-tile-title>
                                        </v-list-tile-content>
                                        <span class="body-1"><b>Successful:</b> {{ authLevels[0].masterSuccess }} / {{ authLevels[0].masterSuccessRatio }}%</span><br>
                                        <span class="body-1"><b>Failure:</b> {{ authLevels[0].masterFail }} / {{ authLevels[0].masterFailureRatio }}%</span><br>
                                        <span class="body-1"><b>Breach Threshold:</b> {{ authLevels[0].masterBreach }}%</span>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-card>
                            <v-card-title class="primary white--text dense" dense>
                                <v-list-tile-title class="subheading font-weight-regular">Agent Statistics</v-list-tile-title>
                            </v-card-title>

                            <v-data-table id="agents-table" :headers="agentHeaders" :items="agentStats" hide-actions>
                                <template v-slot:items="props">
                                    <td class="text-xs-left">{{ props.item.first_name }} {{ props.item.surname }}</td>
                                    <td class="text-xs-center">{{ props.item.volume }}</td>
                                    <td class="text-xs-center">£{{ props.item.amount }}</td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template> 

<script>
    import renderTransactionsValueComparison from '../charts.js';
    import renderTransactionsVolumeComparison from '../charts.js';
    import axios from 'axios';

    export default {
        data () {
            return {
                headers: [ { text: 'Day', sortable: false },
                           { text: 'Debit Val.', sortable: false },
                           { text: 'Debit Vol.', sortable: false },
                           { text: 'Credit Val.', sortable: false },
                           { text: 'Credit Vol.', sortable: false },
                           { text: 'Rejected Val.', sortable: false },
                           { text: 'Rejected Vol.', sortable: false },
                           { text: 'Failure Rate Val.', sortable: false },
                           { text: 'Failure Rate Vol.', sortable: false } ],
                agentHeaders: [ { text: 'Agent Name', sortable: false },
                                 { text: 'Transactions', sortable: false, align: 'center' },
                                 { text: 'Revenue', sortable: false, align: 'center' }],
                data: [],
                loading: false,
                canvasValue: null,
                merchant: [],
                merchantUuid: null,
                userId: localStorage.user_id,
                scheduleStats: null,
                paymentStats: [],
                agentStats: [],
                authLevels: null
            }
        },
        mixins: [ renderTransactionsValueComparison, renderTransactionsVolumeComparison ],
        mounted() {
            this.canvasValue = this.$refs['transactions-value-weekly-comparison'].getContext('2d');
            this.canvasVolume = this.$refs['transactions-volume-weekly-comparison'].getContext('2d');
        },
        beforeMount() {
            this.getMerchants();
        },
        computed: {
            breach: function() {
                return this.authLevels[0].visaBreach <= 50.00 ? 'breach-green'
                       : this.authLevels[0].visaBreach > 50.00 && this.authLevels[0].visaBreach <= 75.00 ? 'breach-orange'
                       : 'breach-red';
            }
        },
        methods: {
            getMerchants() {
                axios({
                method: 'post',
                data: { userId: localStorage.user_id },
                url: 'https://controlapi.totalprocessing.com/api/client-get-merchant',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchant = response.data;
                    this.defaultSelect = this.merchant[0].uuid;
                    this.merchantUuid = this.merchant[0].uuid;
                    this.getDashboardWeeklyStats();
                    this.getDashboardPaymentStats();
                    this.getDashboardScheduleStats();
                    this.getAgentStats();
                    this.getAuthLevels();
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getDashboardWeeklyStats() {
                this.loading = true;

                axios({
                method: 'post',
                data: { userId: localStorage.user_id, merchantUuid: this.merchantUuid },
                url: 'https://controlapi.totalprocessing.com/api/client-get-dashboard-weekly-stats',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.loading = false;
                    this.data = response.data;
                    this.renderTransactionsValueComparison(this.canvasValue, this.data, 'weekly');
                    this.renderTransactionsVolumeComparison(this.canvasVolume, this.data, 'weekly');
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getDashboardScheduleStats() {
                axios({
                method: 'post',
                data: { merchantUuid: this.merchantUuid },
                url: 'https://controlapi.totalprocessing.com/api/client-get-dashboard-schedule-stats',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.scheduleStats = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getDashboardPaymentStats() {
                axios({
                method: 'post',
                data: { merchantUuid: this.merchantUuid },
                url: 'https://controlapi.totalprocessing.com/api/client-get-dashboard-payment-stats',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.paymentStats = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getAgentStats() {
                axios({
                method: 'post',
                data: { merchantUuid: this.merchantUuid },
                url: 'https://controlapi.totalprocessing.com/api/client-get-agent-stats',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.agentStats = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getAuthLevels() {
                axios({
                method: 'post',
                data: { merchantUuid: this.merchantUuid },
                url: 'https://controlapi.totalprocessing.com/api/client-get-auth-levels',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.authLevels = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
        }
    }
</script>

<style>

#comparison-table .v-table thead th,
#dashboard-comparison-table .v-table tbody td {
    padding: 0px 20px;
}

#comparison-table .v-table thead tr.v-datatable__progress > th.column {
    padding: 0px;
}

.comparison-table-title {
    font-size: 12px;
    font-weight: 600;
    color: rgba(0, 0, 0, .54);
    padding: 15px 0px 0px 0px !important;
}

.breach-green {
    background: #66bb6a !important;
    color: #fff !important;
}

.breach-red {
    background: #fb8c00 !important;
    color: #fff !important;
}

.breach-red {
    background: #e53835 !important;
    color: #fff !important;
}
</style>
